import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CadAgendaAnexoOnline } from '../interfaces/cad-agenda-anexo-online';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class CadAgendaAnexoOnlineService {

  readonly path = '/agenda/anexo';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}


  getCadAgendaAnexo(id: number, generatePresignedUrl = false){
    return this.http.get<CadAgendaAnexoOnline>(`${this.jwtAuthService.apiUrl+ this.path}/${id}?generatePresignedUrl=${generatePresignedUrl}`); 
  }

  getCadAgendaAnexoOnlinePage(agendaControle: number, page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<CadAgendaAnexoOnline>> {
    return this.http.get<PageResult<CadAgendaAnexoOnline>>(`${this.jwtAuthService.apiUrl 
      + this.path}/page/get?page=${page}&size=${size}&cadAgendaControle=${agendaControle}&order=${order}&direction=${direction}`);
  }

  getCadAgendaAnexoOnlinePageSearch(search:string, agendaControle: number, page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<CadAgendaAnexoOnline>> {
    return this.http.get<PageResult<CadAgendaAnexoOnline>>(`${this.jwtAuthService.apiUrl 
      + this.path}/page/get?search=${search}&page=${page}&size=${size}&cadAgendaControle=${agendaControle}&order=${order}&direction=${direction}`);
  }

  downloadAnexo(anexoId: number ): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/download/${anexoId}`
    , {responseType: 'arraybuffer'});
  }

  delete(id: number): Observable<any> {
    console.log('delete');
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

}

